import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { GetWorkbookAccelerationsRequest } from '../../workbook/ServerApi/requests/GetWorkbookAccelerationsRequest';
import { IWorkbookAccelerationInfo } from '../../workbook/ServerApi/types/IWorkbookAccelerationInfo';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { IListResource } from './Resource';
import { ResourceQuery } from './ResourceQuery';

export class WorkbookAccelerationsResource implements IListResource<IWorkbookAccelerationInfo> {

  private listFetcher = new WebClientListResourceFetcher(GetWorkbookAccelerationsRequest, ServerApiMapper.workbookAccelerations);

  public all(): ResourceQuery<IWorkbookAccelerationInfo> {
    return new ResourceQuery(this.listFetcher);
  }
}

export const WorkbookAccelerations = new WorkbookAccelerationsResource();
